<template>
  <div class="page-add-gys">
    <div class="form-section">
      <a-form layout="horizontal">
        <a-form-item label="供应商名称" :label-col="{span: 3}" :wrapper-col="{span: 21}">
          <a-input :value="detail.gysName" read-only style="width: 240px;" />
        </a-form-item>
        <a-form-item label="供应商账号" :label-col="{span: 3}" :wrapper-col="{span: 21}">
          <a-input :value="detail.userName" read-only style="width: 240px;" />
        </a-form-item>
      </a-form>
    </div>

    <!-- 分项工程列表 -->
    <div class="table-section">
      <a-table
        :columns="itemColumns"
        :dataSource="itemList"
        :pagination="false"
        rowKey="id"
        bordered
      />
    </div>

    <div class="footer-actions" style="text-align: right; margin-top: 16px;">
      <a-button type="primary" @click="$router.go(-1)">返回</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GysglDetail',
  data () {
    return {
      detail: {},
      itemList: [],
      itemColumns: [
        { title: '分项工程名称', dataIndex: 'projectName', width: 200, align: 'center' },
        { title: '项目特征描述', dataIndex: 'featureDesc', width: 200, align: 'center' },
        { title: '单位', dataIndex: 'unit', width: 100, align: 'center' },
        { title: '全费用综合单价（元）', dataIndex: 'fullPrice', width: 180, align: 'center' }
      ]
    }
  },
  mounted () {
    const id = this.$route.query.id
    if (id) {
      this.$axios.post('/api/gysgl/detail.do', { id }).then(res => {
        this.detail = res.data.data || {}
      })
      this.$axios.post('/api/gysgl/projectInfo/list.do', { gysId: id }).then(res => {
        this.itemList = (res.data && res.data.list) || []
      })
    }
  }
}
</script>
